import { appContext } from "../../../AppContext";
import BuildingSelector from "../BuildingSelector/BuildingSelector";
import { MenuItemKey } from "./MenuItemKey";
import { ReactComponent as HomeIcon } from './icons/Home.svg';
import { ReactComponent as SetupIcon } from './icons/Setup.svg';
import { ReactComponent as ManageIcon } from './icons/Manage.svg';
import { ReactComponent as SecurityIcon } from './icons/Security.svg';
import { ReactComponent as OrganisationIcon } from './icons/Organisation.svg';
import { ReactComponent as UsersIcon } from './icons/Users.svg';
import { ReactComponent as BookingPoliciesIcon } from './icons/BookingPolicy.svg';
import { ReactComponent as FloorIcon } from './icons/Floor.svg';
import { ReactComponent as FileManagementIcon } from './icons/FileManagement.svg';
import { ReactComponent as HistogramIcon } from './icons/SoundLevel.svg';
import { ReactComponent as LeafIcon } from './icons/Leaf.svg';
import { ReactComponent as SearchIcon } from './icons/Search.svg';
import { ReactComponent as CalendarIcon } from './icons/Calendar.svg';
import { ReactComponent as MyTasksIcon } from './icons/MyTasks.svg';
import { ReactComponent as CategoryIcon } from './icons/Category.svg';
import { ReactComponent as VisitorManagementIcon } from './icons/VisitorManagement.svg';
import { ReactComponent as TasksIcon } from './icons/Tasks.svg'
import { ReactComponent as WorkplaceIcon } from './icons/Workplace.svg'
import { ReactComponent as BellIcon } from './icons/Bell.svg';
import { ReactComponent as HotDrinkIcon } from './icons/HotDrink.svg';
import { ReactComponent as SpacesIcon } from './icons/Spaces.svg';
import { ReactComponent as CleaningIcon } from './icons/Cleaning.svg';
import { ReactComponent as AdminPortalIcon } from './icons/AdminPortal.svg'
import { ReactComponent as FlexIcon } from './icons/Flex.svg';
import { ReactComponent as OneLensIcon } from './icons/OneLens.svg';
import { ReactComponent as CostCodeIcon } from './icons/CostCode.svg'
import { ReactComponent as OrphanedRecordsIcon } from './icons/Warning.svg'
import { ReactComponent as FindColleagueIcon } from './icons/FindAColleague.svg';
import { ReactComponent as BuildingIcon } from './icons/Building.svg';
import { ReactComponent as TagIcon } from './icons/Tags.svg';
import { ReactComponent as FlexScheduleIcon } from './icons/Schedule.svg';
import { ReactComponent as DelegateIcon } from './icons/Delegate.svg';
import { ReactComponent as AnnouncementsIcon } from './icons/Announcements.svg';
import { ReactComponent as SystemFilterIcon } from './icons/SystemFilter.svg';
import { ReactComponent as SpaceBusy } from './icons/SpaceBusy.svg';
import { SearchSpacesHelper } from "../../../Pages/Shared/Spaces/Search/SearchSpacesHelper";
import { ReactComponent as LinkedSpace } from './icons/LinkedSpace.svg';
import { ReactComponent as PersonalisedExperience } from './icons/PersonalisedExperience.svg';
import { rights } from '../../../Common/RightsManager';

enum IIconPosition
{
    Left = "LEFT",
    Right = "RIGHT",
}


export class MenuItems
{
    private labels = appContext().labels;
    private appState = appContext().state;
    private local = appContext().localStorageProvider;
    public menuItems = new Array<IMenuItem>();

    constructor()
    {
        const labels = this.labels;
        this.menuItems =
            [
                {
                    id: MenuItemKey.Flex,
                    label: labels.HubMenuFlex,
                    link: () => null,
                    permissions: rights.FLEX.has(),
                    appMenu: "flex",
                    titleImageUrl: "/images/Flex Menu Hero (Switcher).svg",
                    icon: {
                        name: "flex",
                        position: IIconPosition.Left,
                        component: FlexIcon,
                    },
                    children:
                        [
                            {
                                id: MenuItemKey.Flex_Home,
                                label: labels.HubMenuHome,
                                link: () => "/flex-home/",
                                appMenu: 'flex',
                                permissions: true,
                                children: [],
                                icon:
                                {
                                    name: 'home',
                                    position: IIconPosition.Left,
                                    component: HomeIcon,
                                },
                            },

                            {
                                id: MenuItemKey.Flex_FindASpace,
                                label: labels.HubMenuSearchaSpace,
                                link: () => null,
                                appMenu: 'flex',
                                permissions: (rights.FLEX.Search.Spaces.has()),
                                children: [
                                    {
                                        id: MenuItemKey.Flex_FindASpace_Single,
                                        label: labels.HubLabelSingleBooking,
                                        link: () => `/flex/spaces/search?${SearchSpacesHelper.buildQuery()}`,
                                        permissions: (rights.FLEX.SearchSpaces.Single.has()),
                                        children: [],
                                    },
                                    {
                                        id: MenuItemKey.Flex_FindASpace_Recurring,
                                        label: this.labels.funcAdvancedBooking_Short,
                                        link: () => "/flex-recurring-booking",
                                        permissions: (rights.FLEX.SearchSpaces.Advanced.has()),
                                        children: [],
                                    }
                                ],
                                icon: {
                                    name: 'magnifying glass',
                                    position: IIconPosition.Left,
                                    component: SearchIcon,
                                }
                            },
                            {
                                id: MenuItemKey.Flex_FindAColleague,
                                label: labels.HubMenuFindColleague,
                                link: () => "/flex/users/search-colleagues",
                                appMenu: 'flex',
                                permissions: rights.FLEX.SearchPeople.Colleague.has(),
                                children: [],
                                icon: {
                                    name: labels.HubMenuFindColleague,
                                    position: IIconPosition.Left,
                                    component: FindColleagueIcon,
                                }
                            },
                            {
                                id: MenuItemKey.Flex_Schedule,
                                label: this.labels.Flex_SpacesScheduleView_Menu,
                                link: () => "/flex/schedule-view",
                                appMenu: 'flex',
                                permissions: rights.FLEX.SearchSpaces.Single.has(),
                                children: [],
                                icon: {
                                    name: 'schedule',
                                    position: IIconPosition.Left,
                                    component: FlexScheduleIcon,
                                }
                            },
                            {
                                id: MenuItemKey.Flex_MyEvents,
                                label: this.labels.funcMyEvents_S,
                                link: () => '/flex/events/mine',
                                appMenu: 'flex',
                                permissions: rights.FLEX.Events.View.has() && rights.DATAMODEL.TicketedEvents.Read.has(),
                                children: [],
                                icon: {
                                    name: 'my events',
                                    position: IIconPosition.Left,
                                    component: PersonalisedExperience,
                                }
                            },
                            {
                                id: MenuItemKey.Flex_MySchedule,
                                label: labels.HubMenumySchedule,
                                link: () => null,
                                appMenu: 'flex',
                                permissions: rights.FLEX.MySchedule.has(),
                                icon: {
                                    name: 'schedule',
                                    position: IIconPosition.Left,
                                    component: CalendarIcon,
                                },
                                children: [
                                    {
                                        id: MenuItemKey.Flex_MySchedule_MyBookings,
                                        label: labels.HubMenuBookings,
                                        link: () => "/flex-my-bookings",
                                        permissions: (rights.FLEX.MySchedule.MyBookings.has()),
                                        children: [],
                                        icon: {
                                            name: 'bookings',
                                            position: IIconPosition.Left,
                                            component: CategoryIcon,
                                        },
                                    },
                                    {
                                        id: MenuItemKey.Flex_MySchedule_MyVisitors,
                                        label: labels.HubMenuVisitors,
                                        link: () => "/flex/visits",
                                        permissions: (rights.FLEX.MySchedule.MyVisitors.has()),
                                        children: [],
                                        icon: {
                                            name: 'visitors',
                                            position: IIconPosition.Left,
                                            component: VisitorManagementIcon,
                                        },
                                    },
                                    {
                                        id: MenuItemKey.Flex_MySchedule_MyBookingsForOthers,
                                        label: labels.HubMenuBookingsForOthers,
                                        link: () => "/flex-my-bookings-for-others",
                                        permissions: (rights.FLEX.MySchedule.MyBookingsForOthers.has()),
                                        children: [],
                                        icon: {
                                            name: 'bookings for others',
                                            position: IIconPosition.Left,
                                            component: CalendarIcon,
                                        },

                                    },
                                    {
                                        id: MenuItemKey.Flex_MySchedule_PrimaryBookings,
                                        label: this.labels.HubLabelBookingsForPrimaries,
                                        link: () => "/flex/bookings/primaries",
                                        permissions: (rights.FLEX.MySchedule.MyBookings.has()),
                                        children: [],
                                        icon: {
                                            name: 'bookings for primaries',
                                            position: IIconPosition.Left,
                                            component: SpaceBusy,
                                        },
                                    },
                                ]
                            },
                            {
                                id: MenuItemKey.Flex_MyNotification,
                                label: labels.HubMenuMyNotifications,
                                link: () => "/flex-my-notification",
                                appMenu: 'flex',
                                permissions: (rights.DATAMODEL.Notifications.Read.has()),
                                children: [],
                                icon: {
                                    name: 'bell',
                                    position: IIconPosition.Left,
                                    component: BellIcon
                                }
                            },
                            {
                                id: MenuItemKey.Flex_MyTasks,
                                label: labels.HubMenuMyTask,
                                link: () => null,
                                appMenu: 'flex',
                                permissions: rights.FLEX.MyTasks.has(),
                                icon: {
                                    name: 'tasks',
                                    position: IIconPosition.Left,
                                    component: MyTasksIcon,
                                },
                                children: [
                                    {
                                        id: MenuItemKey.Flex_MyTask_TasksRaised,
                                        label: labels.HubMenuTasksRaised,
                                        link: () => `/flex-my-tasks?building=${this.appState.buildingId}`,
                                        permissions: (rights.FLEX.MyTasks.MyTasks.has()),
                                        children: [],
                                        icon: {
                                            name: 'tasks',
                                            position: IIconPosition.Left,
                                            component: TasksIcon,
                                        },
                                    },
                                ]
                            },
                            {
                                id: MenuItemKey.Flex_Settings,
                                label: labels.HubMenuSettings,
                                link: () => null,
                                appMenu: "flex",
                                permissions: rights.FLEX.UserPreferences.has(),
                                icon: {
                                    name: 'settings',
                                    position: IIconPosition.Left,
                                    component: UsersIcon,
                                },
                                children: [
                                    {
                                        id: MenuItemKey.Flex_Settings_Notifications,
                                        label: labels.HubLabelNotifications,
                                        link: () => "/flex-user-pref-notifications",
                                        permissions: (rights.FLEX.UserPreferences.has()),
                                        children: [],
                                        icon: {
                                            name: 'bell',
                                            position: IIconPosition.Left,
                                            component: BellIcon,
                                        },
                                    },
                                    {
                                        id: MenuItemKey.Flex_Settings_Workplace,
                                        label: labels.HubMenuWorkplacePreferences,
                                        link: () => "/flex-user-pref-workplace",
                                        permissions: (rights.FLEX.UserPreferences.Workplace.has()),
                                        children: [],
                                        icon: {
                                            name: 'tasks',
                                            position: IIconPosition.Left,
                                            component: WorkplaceIcon,
                                        },
                                    },
                                    {
                                        id: MenuItemKey.Flex_Settings_Account,
                                        label: labels.HubMenuAccountSettings,
                                        link: () => "/flex-user-pref-account",
                                        permissions: (rights.FLEX.UserPreferences.AccountSettings.has()),
                                        children: [],
                                        icon: {
                                            name: 'cog',
                                            position: IIconPosition.Left,
                                            component: SetupIcon,
                                        },
                                    },
                                    {
                                        id: MenuItemKey.Flex_Settings_CostCodes,
                                        label: this.labels.funcMenuDefaultCostCodes_Short,
                                        link: () => "/flex/settings/default-cost-codes",
                                        permissions: (rights.FLEX.UserPreferences.CostCodes.has()),
                                        children: [],
                                        icon: {
                                            name: 'default cost code',
                                            position: IIconPosition.Left,
                                            component: CostCodeIcon,
                                        },
                                    },
                                    {
                                        id: MenuItemKey.Flex_Settings_DelegatePermissions,
                                        label: labels.funcDelegatePermissions_S,
                                        link: () => "/flex/delegates/create",
                                        permissions: rights.FLEX.UserPreferences.Delegates.has(),
                                        children: [],
                                        icon: {
                                            name: 'delegate',
                                            position: IIconPosition.Left,
                                            component: DelegateIcon,
                                        },
                                    },
                                    {
                                        id: MenuItemKey.Flex_Settings_DelegateAccess,
                                        label: labels.funcDelegateAccess_S,
                                        link: () => "/flex/delegates",
                                        permissions: rights.FLEX.UserPreferences.Delegates.has(),
                                        children: [],
                                        icon: {
                                            name: 'delegate',
                                            position: IIconPosition.Left,
                                            component: DelegateIcon,
                                        },
                                    }
                                ]
                            }
                        ]
                },
                {
                    id: MenuItemKey.OneLens,
                    label: labels.HubMenuoneLens360,
                    link: () => null,
                    permissions: rights.ONELENS360.has(),
                    appMenu: "onelen360",
                    titleImageUrl: "/images/OneLens360 Menu Hero.svg",
                    icon: {
                        name: 'OneLens360',
                        position: IIconPosition.Left,
                        component: OneLensIcon,
                    },
                    children:
                        [
                            {
                                id: MenuItemKey.OneLens_BuildingSelector,
                                label: '',
                                link: () => null,
                                permissions: true,
                                children: [],
                                component: BuildingSelector
                            },
                            {
                                id: MenuItemKey.OneLens_Home,
                                label: labels.HubMenuHome, // Home
                                link: () => "/operational-services-home/",
                                appMenu: "onelen360",
                                permissions: true,
                                icon: {
                                    name: 'home',
                                    position: IIconPosition.Left,
                                    component: HomeIcon,
                                },
                                children: []
                            },
                            {
                                id: MenuItemKey.OneLens_Operations,
                                label: labels.HubMenuOperations, //'Operations'
                                link: () => null,
                                appMenu: "onelen360",
                                permissions: rights.ONELENS360.OperationalServices.has(),
                                icon: {
                                    name: 'cog',
                                    position: IIconPosition.Left,
                                    component: SetupIcon,
                                },
                                children: [
                                    {
                                        id: MenuItemKey.OneLens_Operations_Bookings,
                                        label: labels.OneLens_Bookings_MenuItem,
                                        link: () => null,
                                        permissions: (rights.ONELENS360.OperationalServices.Bookings.has()),
                                        children: [
                                            {
                                                id: MenuItemKey.OneLens_Operations_Bookings_Dashboard,
                                                label: labels.funcBookingDashboard_S,
                                                link: () => `/buildings/${this.appState.buildingId}/bookings/dashboard`,
                                                permissions: (rights.ONELENS360.OperationalServices.Bookings.has()),
                                                children: []
                                            },
                                            {
                                                id: MenuItemKey.OneLens_Operations_Bookings_List,
                                                label: labels.HubLabelBookingList,
                                                link: () => "/operational-services-bookings-list/" + this.appState.buildingId.toString(),
                                                permissions: (rights.ONELENS360.OperationalServices.Bookings.has()),
                                                children: [],
                                            },
                                            {
                                                id: MenuItemKey.OneLens_Operations_Bookings_Trends,
                                                label: labels.HubLabelBookingTrends,
                                                link: () => `/buildings/${this.appState.buildingId}/bookings/trends`,
                                                permissions: (rights.ONELENS360.OperationalServices.Bookings.has()),
                                                children: [],
                                            },
                                            {
                                                id: MenuItemKey.OneLens_Operations_Bookings_ScheduleView,
                                                label: labels.HubLabelScheduleView,
                                                link: () => `/buildings/${this.appState.buildingId.toString()}/bookings/schedule-view`,
                                                permissions: (rights.ONELENS360.OperationalServices.ScheduleView.has()),
                                                children: [],
                                            }
                                        ],
                                        icon: {
                                            name: 'calendar',
                                            position: IIconPosition.Left,
                                            component: CalendarIcon,
                                        },
                                    },
                                    {
                                        id: MenuItemKey.Onelens_Operations_Events,
                                        label: this.labels.funcEvents_S,
                                        link: () => null,
                                        permissions: (rights.ONELENS360.OperationalServices.Events.has() && rights.DATAMODEL.TicketedEvents.Read.has()),
                                        children: [
                                            {
                                                id: MenuItemKey.Onelens_Operations_Events_List,
                                                label: this.labels.funcEventList_S,
                                                link: () => `/one-lens/events?building=${this.appState.buildingId}`,
                                                permissions: (rights.ONELENS360.OperationalServices.Events.has() && rights.DATAMODEL.TicketedEvents.Read.has()),
                                                children: []
                                            },
                                        ],
                                        icon: {
                                            name: 'my events',
                                            position: IIconPosition.Left,
                                            component: PersonalisedExperience,
                                        }
                                    },
                                    {
                                        id: MenuItemKey.OneLens_Operations_Visitors,
                                        label: labels.OneLens_Visitors_MenuItem,
                                        link: () => null,
                                        permissions: (rights.ONELENS360.OperationalServices.Visitors.has()),
                                        icon: {
                                            name: 'visitor management',
                                            position: IIconPosition.Left,
                                            component: VisitorManagementIcon,
                                        },
                                        children: [
                                            {
                                                id: MenuItemKey.OneLens_Operations_Visitors_Dashboard,
                                                label: labels.HubLabelVisitorDashboard,
                                                link: () => "/operational-services-visitors-dashboard/" + this.appState.buildingId.toString(),
                                                permissions: (rights.ONELENS360.OperationalServices.Visitors.has()),
                                                children: [],
                                            },
                                            {
                                                id: MenuItemKey.OneLens_Operations_Visitors_List,
                                                label: labels.HubLabelVisitorList,
                                                link: () => `/one-lens/visits?building=${this.appState.buildingId}`,
                                                permissions: (rights.ONELENS360.OperationalServices.Visitors.has()),
                                                children: [],
                                            },
                                            {
                                                id: MenuItemKey.OneLens_Operations_Visitors_Trends,
                                                label: labels.HubLabelVisitorTrends,
                                                link: () => "/operational-services-visitors-trends/" + this.appState.buildingId.toString(),
                                                permissions: (rights.ONELENS360.OperationalServices.Visitors.has()),
                                                children: [],
                                            },
                                        ],
                                    },
                                    {
                                        id: MenuItemKey.OneLens_Operations_Catering,
                                        label: labels.HubMenuCatering,
                                        link: () => null,
                                        permissions: rights.ONELENS360.OperationalServices.Catering.has(),
                                        icon: {
                                            name: 'hot drink',
                                            position: IIconPosition.Left,
                                            component: HotDrinkIcon,
                                        },
                                        children: [
                                            {
                                                id: MenuItemKey.OneLens_Operations_Catering_CateringOrders,
                                                label: labels.HubMenuCateringOrders, //'Catering Orders',
                                                link: () => `/one-lens/catering-orders?building=${this.appState.buildingId}`,
                                                permissions: rights.ONELENS360.OperationalServices.Catering.has() && rights.DATAMODEL.CateringOrders.Read.has(),
                                                children: [],
                                            },
                                            {
                                                id: MenuItemKey.OneLens_Operations_Catering_PantryTimeline,
                                                label: labels.HubCateringPantryTimeline, //'Pantry Timeline'
                                                link: () => "/oneLens/" + this.appState.buildingId.toString() + "/catering/pantry-timeline",
                                                permissions: rights.ONELENS360.OperationalServices.Catering.has(),
                                                children: [],
                                            },
                                            {
                                                id: MenuItemKey.Onelens_Operations_Catering_Suppliers,
                                                label: labels.HubLabelMenuCateringSuppliers, //'Catering Suppliers'
                                                link: () => `/buildings/${this.appState.buildingId.toString()}/catering-suppliers`,
                                                permissions: rights.ONELENS360.OperationalServices.Catering.has() && rights.DATAMODEL.CateringSuppliers.Read.has(),

                                                children: [],
                                            },
                                            {
                                                id: MenuItemKey.Onelens_Operations_Catering_DietaryTerms,
                                                label: this.labels.funcCateringDietaryTerms_S, //'Dietary Terms'
                                                link: () => `/one-lens/catering-dietary-terms?building=${this.appState.buildingId.toString()}`,
                                                permissions: rights.ONELENS360.OperationalServices.Catering.has() && rights.DATAMODEL.CateringRestrictions.Read.has(),
                                                children: [],
                                            },
                                            {
                                                id: MenuItemKey.Onelens_Operations_Catering_OrderPolicy,
                                                label: labels.HubLabelMenuOrderPolicy, //'Catering Privacy Policy'
                                                link: () => "/buildings/" + this.appState.buildingId.toString() + "/catering-order-policies",
                                                permissions: rights.ONELENS360.OperationalServices.Catering.has() && rights.DATAMODEL.CateringOrderPolicies.Read.has(),
                                                children: [],
                                            },
                                            {
                                                id: MenuItemKey.Onelens_Operations_Catering_CateringItems,
                                                label: labels.HubMenuCateringItems, //'Catering Items'
                                                link: () => `/one-lens/catering-items?building=${this.appState.buildingId.toString()}`,
                                                permissions: rights.ONELENS360.OperationalServices.Catering.has() && rights.DATAMODEL.CateringMenuItems.Read.has(),
                                                children: [],
                                            },
                                            {
                                                id: MenuItemKey.Onelens_Operations_Catering_Template,
                                                label: labels.funcCateringTemplate,
                                                link: () => `/one-lens/catering-templates?building=${this.appState.buildingId.toString()}`,
                                                permissions: rights.DATAMODEL.CateringTemplates.Read.has() && rights.ONELENS360.OperationalServices.CateringTemplates.has(),
                                                children: [],
                                            },
                                            {
                                                id: MenuItemKey.Onelens_Operations_Catering_CateringMenus,
                                                label: labels.HubMenuCateringMenus, //'Catering Menus'
                                                link: () => `/one-lens/catering-menus?building=${this.appState.buildingId}`,
                                                permissions: rights.ONELENS360.OperationalServices.Catering.has() && rights.DATAMODEL.CateringMenus.Read.has(),
                                                children: [],
                                            },
                                        ],
                                    },
                                    {
                                        id: MenuItemKey.OneLens_Operations_CostCodes,
                                        label: this.labels.HubLabelCostCodes,
                                        link: () => "/operational-cost-codes/" + this.appState.buildingId.toString(),
                                        permissions: rights.ONELENS360.OperationalServices.CostCodes.has(),
                                        children: [],
                                        icon: {
                                            name: 'cost code',
                                            position: IIconPosition.Left,
                                            component: CostCodeIcon,
                                        }
                                    },
                                    {
                                        id: MenuItemKey.OneLens_Operations_Tasks,
                                        label: labels.HubMenuTasks,
                                        link: () => `/one-lens/tasks?building=${this.appState.buildingId}`,
                                        permissions: (rights.ONELENS360.OperationalServices.Tasks.has()),
                                        children: [],
                                        icon: {
                                            name: 'tasks',
                                            position: IIconPosition.Left,
                                            component: TasksIcon,
                                        },
                                    },
                                    {
                                        id: MenuItemKey.OneLens_Operations_Announcements,
                                        label: this.labels.funcSidebarAnnouncements_Short,
                                        link: () => `/one-lens/announcements?building=${this.appState.buildingId}`,
                                        permissions: (rights.ONELENS360.OperationalServices.Announcements.has()),
                                        children: [],
                                        icon: {
                                            name: 'announcements',
                                            position: IIconPosition.Left,
                                            component: AnnouncementsIcon,
                                        },
                                    },
                                    {
                                        id: MenuItemKey.OneLens_Operations_Notifications,
                                        label: labels.HubMenuOpservNotifications,
                                        link: () => `/one-lens/notifications?building=${this.appState.buildingId}`,
                                        permissions: !!(rights.ONELENS360.OperationalServices.Notifications.has()),
                                        children: [],
                                        icon: {
                                            name: 'bell',
                                            position: IIconPosition.Left,
                                            component: BellIcon,
                                        },
                                    },
                                    {
                                        id: MenuItemKey.OneLens_Operations_Spaces,
                                        label: labels.HubMenuSpaces,
                                        link: () => null,
                                        permissions: rights.ONELENS360.OperationalServices.Spaces.has() || rights.ONELENS360.OperationalServices.SpaceLayouts.has(),
                                        icon:
                                        {
                                            name: 'spaces',
                                            position: IIconPosition.Left,
                                            component: SpacesIcon,
                                        },
                                        children: [
                                            {
                                                id: MenuItemKey.OneLens_Operations_Spaces_Spaces,
                                                label: labels.HubMenuSpaces,
                                                link: () => "/operational-services-spaces/" + this.appState.buildingId.toString(),
                                                permissions: rights.ONELENS360.OperationalServices.Spaces.has(),
                                                children: [],
                                            },
                                            {
                                                id: MenuItemKey.OneLens_Operations_Space_Layouts,
                                                label: this.labels.funcSpaceLayouts_S,
                                                link: () => "/oneLens/" + this.appState.buildingId.toString() + "/space-layouts",
                                                permissions: rights.ONELENS360.OperationalServices.SpaceLayouts.has(),
                                                children: [],
                                            }
                                        ],
                                    },
                                    {
                                        id: MenuItemKey.OneLens_Operations_DirectedCleaning,
                                        label: labels.HubMenuOpservDirectedCleaning,
                                        link: () => "/operational-services-directed-cleaning/" + this.appState.buildingId.toString(),
                                        permissions: (rights.ONELENS360.OperationalServices.DirectedCleaning.has()),
                                        children: [],
                                        icon: {
                                            name: 'cleaning',
                                            position: IIconPosition.Left,
                                            component: CleaningIcon,
                                        },
                                    },
                                    {
                                        id: MenuItemKey.OneLens_Operations_DeletedUsers,
                                        label: this.labels.funcOrphanedBookings_S,
                                        link: () => "/users/deleted",
                                        permissions: (rights.ONELENS360.OperationalServices.OrphanedBookings.has()),
                                        children: [],
                                        icon: {
                                            name: 'orphanedRecords',
                                            position: IIconPosition.Left,
                                            component: OrphanedRecordsIcon,
                                        },
                                    },
                                ]
                            },
                            {
                                id: MenuItemKey.OneLens_Analytics,
                                label: labels.HubMenuAnalytics, //'Analytics'
                                link: () => null,
                                appMenu: "onelens360",
                                permissions: (rights.ONELENS360.SpaceAnalytics.has() || rights.ONELENS360.SustainabilityAnalytics.has()),
                                icon: {
                                    name: 'histogram',
                                    position: IIconPosition.Left,
                                    component: HistogramIcon,
                                },
                                children: [
                                    {
                                        id: MenuItemKey.OneLens_Analytics_Visitors,
                                        label: labels.HubMenuVisitors,
                                        link: () => `/onelens/visits/analytics?node=${this.appState.buildingId}`,
                                        permissions: rights.ONELENS360.VisitorAnalytics.Overview.has(),
                                        children: [],
                                    },
                                    {
                                        id: MenuItemKey.OneLens_Analytics_Sustainability,
                                        label: labels.HubMenuSustainability, //'Sustainability'
                                        link: () => null,
                                        appMenu: "onelen360",
                                        permissions: rights.ONELENS360.SustainabilityAnalytics.has(),
                                        icon: {
                                            name: 'leaf',
                                            position: IIconPosition.Left,
                                            component: LeafIcon,
                                        },
                                        children: [
                                            {
                                                id: MenuItemKey.OneLens_Analytics_Sustainability_Overview,
                                                label: labels.HubMenuOverview,
                                                link: () => "/sustainability-analytics-overview/" + this.appState.buildingId.toString(),
                                                permissions: (rights.ONELENS360.SustainabilityAnalytics.Overview.has()),
                                                children: [],
                                            },
                                            {
                                                id: MenuItemKey.OneLens_Analytics_Sustainability_Floors,
                                                label: labels.HubMenuFloor,
                                                link: () => "/sustainability-analytics-floors/" + this.appState.buildingId.toString(),
                                                permissions: (rights.ONELENS360.SustainabilityAnalytics.Floors.has()),
                                                children: [],
                                            },
                                            {
                                                id: MenuItemKey.OneLens_Analytics_Sustainability_Zones,
                                                label: labels.HubMenuZones,
                                                link: () => "/sustainability-analytics-zones/" + this.appState.buildingId.toString(),
                                                permissions: (rights.ONELENS360.SustainabilityAnalytics.Zones.has()),
                                                children: [],
                                            },
                                            {
                                                id: MenuItemKey.OneLens_Analytics_Sustainability_Sensors,
                                                label: labels.HubMenuSensor,
                                                link: () => "/sustainability-analytics-sensors/" + this.appState.buildingId.toString(),
                                                permissions: (rights.ONELENS360.SustainabilityAnalytics.Sensors.has()),
                                                children: [],
                                            }
                                        ]
                                    },
                                    {
                                        id: MenuItemKey.OneLens_Analytics_Space,
                                        label: labels.HubMenuSpace,
                                        link: () => null,
                                        appMenu: "onelen360",
                                        permissions: rights.ONELENS360.SpaceAnalytics.has(),
                                        icon: {
                                            name: 'spaces',
                                            position: IIconPosition.Left,
                                            component: SpacesIcon,
                                        },
                                        children: [
                                            {
                                                id: MenuItemKey.OneLens_Analytics_Space_Overview,
                                                label: labels.HubLabelSpaceoverview,
                                                link: () => "/space-analytics-overview/" + this.appState.buildingId.toString(),
                                                permissions: (rights.ONELENS360.SpaceAnalytics.Overview.has()),
                                                children: [],
                                            },
                                            {
                                                id: MenuItemKey.OneLens_Analytics_Space_Heatmaps,
                                                label: labels.HubMenuHeatMaps,
                                                link: () => `/one-lens/spaces/heatmaps?building=${this.appState.buildingId}`,
                                                permissions: (rights.ONELENS360.SpaceAnalytics.Heatmaps.has()),
                                                children: [],
                                            }
                                        ]
                                    },
                                ]
                            },
                        ]
                },
                {
                    id: MenuItemKey.Admin,
                    label: labels.HubMenuAdminPortal,
                    link: () => null,
                    appMenu: "adminPortal",
                    permissions: rights.ADMINPORTAL.has() && rights.ADMINPORTAL.Security.has(),
                    titleImageUrl: "/images/Admin Portal Menu Hero.svg",
                    icon: {
                        name: 'admin',
                        position: IIconPosition.Left,
                        component: AdminPortalIcon,
                    },
                    children: [
                        // ***** new admin menu *****
                        // remove until we have the admin home route and admin home pages. 
                        // {
                        //     id: MenuItemKey.Admin_Home,
                        //     label: labels.HubMenuHome, //'Home',
                        //     link: () => null,
                        //     appMenu: 'adminPortal', 
                        //     permissions: rights.ADMINPORTAL.has(),
                        //     icon: {
                        //         name: 'home',
                        //         position: IIconPosition.Left,
                        //         component: HomeIcon,
                        //     },
                        //     children: [],
                        // },

                        {
                            id: MenuItemKey.Admin_Setup,
                            label: labels.HubMenuSetup, //'Setup',
                            link: () => null,
                            appMenu: 'adminPortal',
                            permissions: rights.ADMINPORTAL.has(),
                            icon: {
                                name: 'setup',
                                position: IIconPosition.Left,
                                component: SetupIcon,
                            },
                            children: [
                                {
                                    id: MenuItemKey.Admin_Setup_Security,
                                    label: labels.HubMenuSecurity,
                                    link: () => null,
                                    appMenu: "adminPortal",
                                    permissions: rights.ADMINPORTAL.Security.has(),
                                    subLabel: labels.HubMenuSecuritySetup, //'Security setup for system',
                                    icon: {
                                        name: 'lock',
                                        position: IIconPosition.Right,
                                        component: SecurityIcon,
                                    },
                                    children: [
                                        {
                                            id: MenuItemKey.Admin_Setup_Security_IdentityProviders,
                                            label: labels.HubMenuIdentityproviders,
                                            link: () => "/security-identity-providers",
                                            permissions: (rights.ADMINPORTAL.Security.IdentityProviders.has()),
                                            children: [],
                                        },
                                        {
                                            id: MenuItemKey.Admin_Setup_Security_Roles,
                                            label: labels.HubMenuRolesDataSecurity, //'Roles & Data Security'
                                            link: () => "/security-roles",
                                            permissions: (rights.ADMINPORTAL.Security.Roles.has()),
                                            children: [],
                                        },
                                        {
                                            id: MenuItemKey.Admin_Setup_Security_DelegatePermissions,
                                            label: labels.funcDelegatePermissions_S,
                                            link: () => "/admin/delegates/create",
                                            permissions: rights.ADMINPORTAL.Security.Delegates.has(),
                                            children: [],
                                        },
                                    ],
                                },
                                /* comment out the organisation section until rights.ADMINPORTAL.notifications is resolved. */
                                {
                                    id: MenuItemKey.Admin_Setup_Organisation,
                                    label: labels.HubMenuOrganisation,
                                    subLabel: labels.HubMenuSetupClient, //'Setup client'
                                    link: () => null,
                                    appMenu: 'adminPortal',
                                    permissions: !!((rights.ADMINPORTAL.PortfolioSetup.Spaces.has() || rights.ADMINPORTAL.PortfolioSetup.SpacesStar.has())),
                                    icon: {
                                        name: 'organisation',
                                        position: IIconPosition.Right,
                                        component: OrganisationIcon,
                                    },
                                    children: [
                                        {
                                            id: MenuItemKey.Admin_Setup_Organisation_Buildings,
                                            label: labels.HubMenuBuildings,
                                            link: () => "/admin/buildings",
                                            appMenu: 'adminPortal',
                                            permissions: rights.ADMINPORTAL.PortfolioSetup.Buildings.has(),
                                            children: [],
                                            icon: {
                                                name: 'building',
                                                position: IIconPosition.Left,
                                                component: ManageIcon,
                                            }
                                        },
                                        {
                                            id: MenuItemKey.Admin_Setup_Organisation_Regions,
                                            label: labels.HubMenuRegions,
                                            link: () => "/portfolio-setup-spaces/filter=Region",
                                            appMenu: 'adminPortal',
                                            permissions: !!((rights.ADMINPORTAL.PortfolioSetup.Spaces.has() || rights.ADMINPORTAL.PortfolioSetup.SpacesStar.has())),
                                            children: [],
                                            icon: {
                                                name: 'region',
                                                // lightIcon: "/Sidebar_Icons/Light_theme/Region.svg",
                                                // darkIcon: "/Sidebar_Icons/Dark_Theme/Region.svg",
                                                // iconActive: "Sidebar_Icons/Active_icons/Region.svg",
                                                // active: false,
                                                // visibility: true,
                                                position: IIconPosition.Left,
                                                component: ManageIcon,
                                            }
                                        },
                                        {
                                            id: MenuItemKey.Admin_Setup_Organisation_Notifications,
                                            label: labels.HubMenuNotificationSetup,
                                            link: () => '/notifications',
                                            appMenu: "adminPortal",
                                            permissions: (rights.ADMINPORTAL.PortfolioSetup.Notifications.has()),
                                            children: [],
                                        },
                                    ],
                                },
                            ],
                        },

                        {
                            id: MenuItemKey.Admin_Manage,
                            label: labels.HubMenuManage, //'Manage'
                            link: () => null,
                            appMenu: 'adminPortal',
                            permissions: rights.ADMINPORTAL.has(),
                            icon: {
                                name: 'manage',
                                position: IIconPosition.Left,
                                component: ManageIcon,
                            },
                            children: [
                                {
                                    id: MenuItemKey.Admin_Manage_Users,
                                    label: labels.HubMenuUsers,
                                    link: () => "/security-users",
                                    permissions: (rights.ADMINPORTAL.Security.Users.has()),
                                    children: [],
                                    icon: {
                                        name: 'user',
                                        position: IIconPosition.Right,
                                        component: UsersIcon,
                                    }
                                },
                                {
                                    id: MenuItemKey.Admin_Manage_CostCodes,
                                    label: this.labels.HubLabelCostCodes,
                                    link: () => `/admin/cost-codes?building=${this.appState.buildingId}`,
                                    permissions: (rights.API.CostCodes.V2.has() && rights.ADMINPORTAL.Manage.CostCodes.has()),
                                    children: [],
                                    icon: {
                                        name: 'cost code',
                                        position: IIconPosition.Left,
                                        component: CostCodeIcon,
                                    }
                                },
                                {
                                    id: MenuItemKey.Admin_Manage_BuildingSelector,
                                    label: '',
                                    link: () => null,
                                    permissions: true,
                                    children: [],
                                    component: BuildingSelector
                                },
                                {
                                    id: MenuItemKey.Admin_Manage_BookingPolicies,
                                    label: labels.HubMenuBookingPolicies,
                                    link: () => '/booking-policies/' + this.appState.buildingId.toString(),
                                    permissions: (rights.ADMINPORTAL.Manage.BookingPolicies.has() && rights.DATAMODEL.BookingPolicies.Read.has()),
                                    children: [],
                                    icon: {
                                        name: 'booking policies',
                                        position: IIconPosition.Right,
                                        component: BookingPoliciesIcon,
                                    }
                                },
                                {
                                    id: MenuItemKey.Admin_Manage_Floor,
                                    label: "Floors",
                                    link: () => `/floors/buildingId=${this.appState.buildingId}`,
                                    permissions: rights.ADMINPORTAL.PortfolioSetup.Spaces.has() && rights.DATAMODEL.Spaces.Read.has(),
                                    children: [],
                                    icon: {
                                        name: 'floors',
                                        position: IIconPosition.Right,
                                        component: FloorIcon,
                                    }
                                },
                                {
                                    id: MenuItemKey.Admin_Manage_Equipment,
                                    label: this.labels.funcEquipment_S,
                                    link: () => null,
                                    appMenu: "adminPortal",
                                    permissions: rights.ADMINPORTAL.PortfolioManagement.Equipment.has(),
                                    icon: {
                                        name: 'equipment management',
                                        position: IIconPosition.Right,
                                        component: SetupIcon,
                                    },
                                    children: [
                                        {
                                            id: MenuItemKey.Admin_Manage_Equipment_Items,
                                            label: "Items",
                                            link: () => `/admin/equipments?building=${this.appState.buildingId}`,
                                            permissions: rights.ADMINPORTAL.PortfolioManagement.Equipment.has(),
                                            children: [],
                                        },
                                        {
                                            id: MenuItemKey.Admin_Manage_Equipment_Stores,
                                            label: this.labels.funcStores_S,
                                            link: () => `/admin/equipment/stores?building=${this.appState.buildingId}`,
                                            permissions: rights.ADMINPORTAL.PortfolioManagement.Equipment.has(),
                                            children: [],
                                        },

                                    ],
                                },
                                {
                                    id: MenuItemKey.Admin_Manage_Signposts,
                                    label: this.labels.funcSignposts_S,
                                    link: () => `/admin/signposts?building=${this.appState.buildingId}`,
                                    permissions: rights.ADMINPORTAL.PortfolioSetup.BuildingKPIs.has(),
                                    children: [],
                                    icon: {
                                        name: 'signposts',
                                        position: IIconPosition.Right,
                                        component: LinkedSpace,
                                    }
                                },
                                {
                                    id: MenuItemKey.Admin_Manage_NotificationRecuring,
                                    label: this.labels.funcNotificationReminders_S,
                                    link: () => '/admin/notification-reminders/' + this.appState.buildingId.toString(),
                                    permissions: rights.ADMINPORTAL.PortfolioManagement.NotificationReminders.has(),
                                    children: [],
                                    icon: {
                                        name: 'notification reminders',
                                        position: IIconPosition.Right,
                                        component: BookingPoliciesIcon,
                                    }
                                },
                                {
                                    id: MenuItemKey.Admin_Manage_SystemFilters,
                                    label: labels.HubMenuSystemFilters,
                                    link: () => `/admin/system-filters/buildingId=${this.appState.buildingId}`,
                                    permissions: (rights.DATAMODEL.Filters.Read.has()),
                                    children: [],
                                    icon: {
                                        name: 'system filters',
                                        position: IIconPosition.Right,
                                        component: SystemFilterIcon,
                                    }
                                },
                                {
                                    id: MenuItemKey.Admin_Manage_Spaces,
                                    label: 'Spaces',
                                    link: () => `/admin/spaces?building=${this.appState.buildingId}`,
                                    permissions: rights.ADMINPORTAL.PortfolioSetup.Spaces.has() && rights.DATAMODEL.Spaces.Read.has(),
                                    children: [],
                                    icon: {
                                        name: 'spaces',
                                        position: IIconPosition.Right,
                                        component: BuildingIcon,
                                    }
                                },
                                {
                                    id: MenuItemKey.Admin_Manage_Tags,
                                    label: this.labels.funcTags_S,
                                    link: () => `/admin/tags/new`,
                                    permissions: (rights.ADMINPORTAL.PortfolioSetup.TagDefinitions.has()),
                                    children: [],
                                    icon: {
                                        name: 'Tags',
                                        position: IIconPosition.Right,
                                        component: TagIcon,
                                    }
                                },
                                // comment out the following block until building selector component and the ability to use buildingSelector's id to define the data returned on these pages is done.
                                // {
                                //     id: MenuItemKey.Admin_PortfolioSetup_Floors,
                                //     label: labels.HubMenuFloorLabel,
                                //     link: "/portfolio-setup-spaces/filter=Floor",
                                //     appMenu: 'adminPortal',
                                //     permissions: !!((rights.ADMINPORTAL.PortfolioSetup.Spaces.has() || rights.ADMINPORTAL.PortfolioSetup.SpacesStar.has())),
                                //     children: [],
                                //     icon: {
                                //         name: 'floor',
                                //         lightIcon: "/Sidebar_Icons/Light_theme/Floor.svg",
                                //         darkIcon: "/Sidebar_Icons/Dark_Theme/Floor.svg",
                                //         iconActive: "Sidebar_Icons/Active_icons/Floor.svg",
                                //         active: false,
                                //         visibility: true,
                                //         position: IIconPosition.Left,
                                //     }
                                // },
                                // {
                                //     id: MenuItemKey.Admin_PortfolioSetup_Zones,
                                //     label: labels.HubMenuZones,
                                //     link: "/portfolio-setup-spaces/filter=Zone",
                                //     appMenu: 'adminPortal',
                                //     permissions: !!((rights.ADMINPORTAL.PortfolioSetup.Spaces.has() || rights.ADMINPORTAL.PortfolioSetup.SpacesStar.has())),
                                //     children: [],
                                //     icon: {
                                //         name: 'zone',
                                //         lightIcon: "/Sidebar_Icons/Light_theme/Zone.svg",
                                //         darkIcon: "/Sidebar_Icons/Dark_Theme/Zone.svg",
                                //         iconActive: "Sidebar_Icons/Active_icons/Zone.svg",
                                //         active: false,
                                //         visibility: true,
                                //         position: IIconPosition.Left,
                                //     }
                                // },
                                // {
                                //     id: MenuItemKey.Admin_PortfolioSetup_Rooms,
                                //     label: labels.HubMenuRoomsDesks,
                                //     link: "/portfolio-setup-spaces/filter=Space",
                                //     permissions: !!((rights.ADMINPORTAL.PortfolioSetup.Spaces.has() || rights.ADMINPORTAL.PortfolioSetup.SpacesStar.has())),
                                //     children: [],
                                //     icon: {
                                //         name: 'room',
                                //         lightIcon: "/Sidebar_Icons/Light_theme/Room.svg",
                                //         darkIcon: "/Sidebar_Icons/Dark_Theme/Room.svg",
                                //         iconActive: "Sidebar_Icons/Active_icons/Room.svg",
                                //         active: false,
                                //         visibility: true,
                                //         position: IIconPosition.Left,
                                //     }
                                // },
                                {
                                    id: MenuItemKey.Admin_Manage_FileManagement,
                                    label: labels.HubMenuFileManagement,
                                    link: () => null,
                                    appMenu: "adminPortal",
                                    permissions: rights.ADMINPORTAL.Files.has(),
                                    icon: {
                                        name: 'filemanagement',
                                        position: IIconPosition.Right,
                                        component: FileManagementIcon,
                                    },
                                    children: [
                                        {
                                            id: MenuItemKey.Admin_Manage_FileManagement_Roamer,
                                            label: labels.HubMenuRoamer,
                                            link: () => "/filemgmt/roamer",
                                            permissions: (rights.ADMINPORTAL.Files.Roamer.has()),
                                            children: [],
                                        },
                                        {
                                            id: MenuItemKey.Admin_Manage_FileManagement_Unity,
                                            label: labels.HubMenuUnity,
                                            link: () => "/filemgmt/unity",
                                            permissions: (rights.ADMINPORTAL.Files.Unity.has()),
                                            children: [],
                                        },
                                        {
                                            id: MenuItemKey.Admin_Manage_FileManagement_Inspire,
                                            label: labels.HubMenuInspire,
                                            link: () => "/filemgmt/inspire",
                                            permissions: (rights.ADMINPORTAL.Files.Inspire.has()),
                                            children: [],
                                        },
                                        {
                                            id: MenuItemKey.Admin_Manage_FileManagement_Common,
                                            label: labels.HubMenuCommon,
                                            link: () => "/filemgmt/common",
                                            permissions: (rights.ADMINPORTAL.Files.Common.has()),
                                            children: [],
                                        }
                                    ],
                                },
                                {
                                    id: MenuItemKey.Admin_Manage_VisitorTypes,
                                    label: this.labels.funcVisitorTypesMenuItem_Short,
                                    link: () => `/admin/visitor-types?building=${this.appState.buildingId.toString()}`,
                                    permissions: rights.ADMINPORTAL.PortfolioSetup.VisitorTypes.has(),
                                    children: [],
                                    icon: {
                                        name: 'VisitorTypes',
                                        position: IIconPosition.Right,
                                        component: VisitorManagementIcon,
                                    }
                                },
                            ],
                        },
                    ]

                }
            ];
    }
}

export interface IIconData
{
    name: string,
    component: React.FC,
    position: IIconPosition,
}

// each list of these represent one list of menu items out of the three - Flex, Admin Portal and oneLens360
export interface IMenuItem
{
    id: MenuItemKey,
    label: string,
    subLabel?: string, // an optional 2nd line for 2nd layer menu items.
    link: () => (string | null),
    permissions: boolean,
    icon?: IIconData, // new icon of type React.FC, which can be used with MUI's svgIcon.
    titleImageUrl?: string,
    children: Array<IMenuItem>,
    appMenu?: string, // name of the menu
    component?: React.ComponentType,
}
